<div class="company-container">
  <div class="top-part">
    <div class="top-part-wrap">
      <div class="first-section">
        <h5 class="mb-0 table-title">Bulk Item Labeling</h5>
      </div>
    </div>
  </div>

  <div class="new-entry-body">
    <div class="custom-form">
    <div class="ms-2 custom-form-wraapper">
      <div class="d-flex print-mode" style="gap: 10px">
        <h6 class="mb-0">Print Preview:</h6>
        <div class="form-check form-switch">
          <input
            class="form-check-input"
            type="checkbox"
            id="flexSwitchCheckChecked"
            [(ngModel)]="printMode"
            data-testid="print-preview-toggle"
          />
        </div>
      </div>
      <div class="user-inputs">
        <div class="mb-3 enter">
          <label for="itemNum" class="form-label">Item Number</label>
          <p>:</p>
          <input
            type="text"
            class="form-control"
            id="jobRole"
            name="phone"
            placeholder="Enter Item Number"
            [(ngModel)]="production.barcode"
            data-testid="item-number-input"
          />
        </div>
        <div class="mb-3 enter">
          <label for="itemDescr" class="form-label">Item Description</label>
          <p>:</p>
          <input
            type="text"
            class="form-control"
            id="itemDescr"
            name="phone"
            placeholder="Enter Item Description"
            (ngModelChange)="toggleDesc($event)"
            [(ngModel)]="production.departmentDescr"
            data-testid="item-description-input"
          />
        </div>
        <div class="mb-3 enter" *ngIf="showWeekColor">
          <label for="">Production Cycle</label>
          <p>:</p>
          <select
            class="form-select"
            aria-label="Default select example"
            [(ngModel)]="production.productionCycleId"
            data-testid="production-cycle-select"
          >
            <option value="0" hidden>Select Color</option>
            <option
              *ngFor="let weekColor of weekColorsList"
              [ngValue]="weekColor.id"
            >
              {{ weekColor.displayName }}
            </option>
          </select>
        </div>
        <div class="mb-3 enter">
          <label for="">Print Format</label>
          <p>:</p>
          <select
            class="form-select"
            aria-label="Default select example"
            [(ngModel)]="production.formatTypeId"
            (change)="resetFileds(production.formatTypeId)"
            data-testid="print-format-select"
          >
            <option value="0" hidden>Select Print Format</option>
            <option *ngFor="let label of labels" [ngValue]="label.id">
              {{ label.name }}
            </option>
          </select>
        </div>
        <div class="mb-3 enter">
          <label for="iteSize" class="form-label">Item Size</label>
          <p>:</p>
          <input
            type="text"
            class="form-control"
            id="iteSize"
            name="phone"
            placeholder="Enter Item Size"
            [(ngModel)]="production.sizeDescr"
            [disabled]="!isSize"
            data-testid="item-size-input"
          />
        </div>
        <div class="mb-3 enter">
          <label for="itemPrice" class="form-label">Item Price</label>
          <p>:</p>
          <input
            type="number"
            class="form-control"
            id="itemPrice"
            name="price"
            placeholder="Enter Item Price"
            [(ngModel)]="production.price"
            data-testid="item-price-input"
          />
        </div>

        <div class="mb-3 enter">
          <label for="itemQty" class="form-label">Item Quantity</label>
          <p>:</p>
          <input
            type="number"
            class="form-control"
            id="itemQty"
            name="qty"
            placeholder="Enter Item Quantity"
            [(ngModel)]="production.qty"
            data-testid="item-quantity-input"
          />
        </div>
        <div class="mb-3 enter">
          <label for="">Department (Optional)</label>
          <p>:</p>
          <select
            class="form-select"
            aria-label="Default select example"
            (change)="getCategories()"
            [(ngModel)]="production.departmentId"
            [disabled]="!isDept"
            data-testid="department-select"
          >
            <option value="0" hidden>Select Department</option>
            <option
              *ngFor="let dept of departments"
              [ngValue]="dept.departmentId"
            >
              {{ dept.departmentDescr }}
            </option>
          </select>
        </div>
        <div class="mb-3 enter">
          <label for="">Category (Optional)</label>
          <p>:</p>
          <select
            class="form-select"
            aria-label="Default select example"
            [(ngModel)]="production.categoryId"
            [disabled]="!isCatg"
            data-testid="category-select"
          >
            <option value="0" hidden>Select Category</option>
            <option *ngFor="let catg of categories" [ngValue]="catg.categoryId">
              {{ catg.categoryName }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="d-flex buttons-container">
      <button
        class="btn modal-btn me-2 my-3"
        (click)="reset()"
        data-testid="cancel-button"
      >
        Cancel
      </button>
      <button
        class="btn modal-btn add-btn my-3"
        [disabled]="!production.barcode"
        (click)="printProduction(production)"
        data-testid="print-button"
      >
        Print
      </button>
    </div>
  </div>
  </div>
</div>

<button
  style="display: none"
  #tagButton
  data-bs-toggle="modal"
  href="#exampleModalCenter"
  data-testid="modal-trigger-button"
>
  btn
</button>

<div
  class="modal fade"
  id="exampleModalCenter"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered"
    role="document"
    style="max-width: 400px"
  >
    <div class="modal-content shadow-lg border-0">
      <div class="modal-header border-0 justify-content-end p-2">
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body p-4 text-center">
        <div class="tag-container border rounded overflow-hidden">
          <div
            class="tag-header p-2"
            [style.background-color]="production.color"
          >
            <h1 class="h4 text-white fw-bold m-0">RCS</h1>
            <p class="small text-white m-0">{{ tagClr }}</p>
          </div>

          <div class="tag-body p-3 bg-white">
            <h5 class="fw-bold mb-1">{{ tagDept }}</h5>
            <p class="text-secondary small mb-1">{{ tagCtg }}</p>
            <p class="small mb-2 fw-bold" *ngIf="tagSize">
              Size: {{ tagSize }}
            </p>

            <h2 class="display-6 fw-bold mb-3">$ {{ tagPrice }}</h2>

            <div class="d-flex justify-content-center">
              <ngx-barcode
                [bc-value]="SerialId"
                [bc-display-value]="true"
                [bc-format]="'CODE128'"
                [bc-width]="1.5"
                [bc-height]="60"
              >
              </ngx-barcode>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
